import { useEffect } from 'react';

const useScrollEventListener = (onScroll: () => void) => {
    useEffect(() => {
        window.addEventListener('scroll', onScroll);

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
};

export default useScrollEventListener;
